import ContentFooterContainer from './ContentFooterContainer';

export default ContentFooterContainer;



// WEBPACK FOOTER //
// ./src/components/pages/components/ContentFooter/index.js